// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.dialogue-container {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 30px auto;
  padding: 0 15px;
  width: 100%;
}
.dialogue-container .dialogue-message-container {
  border-radius: 12px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background: linear-gradient(135deg, #ffffff 0%, #F8F8F8 100%);
  border: 1px solid #D1D3D4;
  border-top: 5px solid #0669B3;
  display: flex;
  flex-direction: column;
  max-width: 820px;
  min-height: 180px;
  padding: 32px;
  width: 100%;
}
.dialogue-container .dialogue-message-container .dialogue-message1 {
  color: #19608f;
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
}
.dialogue-container .dialogue-message-container .dialogue-message2 {
  color: #444343;
  font-size: 1.15rem;
  font-weight: 500;
  line-height: 1.5;
  padding-top: 12px;
  text-align: center;
}
.dialogue-container .dialogue-message-container .dialogue-message3 {
  color: #414042;
  font-size: 1rem;
  line-height: 1.6;
  padding-top: 20px;
}
.dialogue-container .dialogue-message-container .dialogue-message3 .guardian-no-student-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.dialogue-container .dialogue-message-container .dialogue-message3 .guardian-no-student-details .info-section {
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #D1D3D4;
  padding: 16px 20px;
}
.dialogue-container .dialogue-message-container .dialogue-message3 .guardian-no-student-details .info-section p {
  color: #444343;
  margin: 0;
}
.dialogue-container .dialogue-message-container .dialogue-message3 .guardian-no-student-details .oe-notice-card {
  border-radius: 8px;
  background-color: #fff9e6;
  border-left: 4px solid #FEBF31;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px 20px;
}
.dialogue-container .dialogue-message-container .dialogue-message3 .guardian-no-student-details .oe-notice-card .oe-notice-header {
  color: #19608f;
  font-size: 1.05rem;
  font-weight: 700;
}
.dialogue-container .dialogue-message-container .dialogue-message3 .guardian-no-student-details .oe-notice-card p {
  color: #444343;
  margin: 0;
}
.dialogue-container .dialogue-message-container .dialogue-message3 .guardian-no-student-details .oe-notice-card .oe-countdown-pill {
  border-radius: 20px;
  align-items: center;
  align-self: flex-start;
  background-color: #FEBF31;
  color: #444343;
  display: inline-flex;
  font-size: 0.9rem;
  font-weight: 700;
  gap: 6px;
  padding: 5px 14px;
}
.dialogue-container .dialogue-message-container .dialogue-message3 .guardian-no-student-details .oe-notice-card .subtext {
  color: #707070;
  font-size: 0.9rem;
  font-style: italic;
}
@media (max-width: 600px) {
  .dialogue-container .dialogue-message-container {
    padding: 20px;
  }
  .dialogue-container .dialogue-message-container .dialogue-message1 {
    font-size: 1.3rem;
  }
  .dialogue-container .dialogue-message-container .dialogue-message2 {
    font-size: 1.05rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SimpleDialog.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AAIJ;AAFI;ECRA,mBDSuC;ECYvC,2CAAA;EDVI,6DAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;AAIR;AAFQ;EACI,cDlBF;ECmBE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAIZ;AADQ;EACI,cDDH;ECEG,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAGZ;AAAQ;EACI,cDxBL;ECyBK,eAAA;EACA,gBAAA;EACA,iBAAA;AAEZ;AAAY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAEhB;AAAgB;EChDZ,kBDiDmD;EACnC,yBAAA;EACA,yBAAA;EACA,kBAAA;AAEpB;AAAoB;EACI,cD3Bf;EC4Be,SAAA;AAExB;AAEgB;EC5DZ,kBD6DmD;EACnC,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AAApB;AAEoB;EACI,cDlEd;ECmEc,kBAAA;EACA,gBAAA;AAAxB;AAGoB;EACI,cDhDf;ECiDe,SAAA;AADxB;AAIoB;EChFhB,mBDiFuD;EACnC,mBAAA;EACA,sBAAA;EACA,yBDhEZ;ECiEY,cDzDf;EC0De,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,QAAA;EACA,iBAAA;AAFxB;AAKoB;EACI,cDpEf;ECqEe,iBAAA;EACA,kBAAA;AAHxB;AASQ;EA9FJ;IA+FQ,aAAA;EANV;EAQU;IACI,iBAAA;EANd;EASU;IACI,kBAAA;EAPd;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
